import { v4 as uuidv4, validate } from 'uuid';
import log from 'loglevel';

export async function storeVoterId(value: string | null) {
  if (typeof value === 'string') {
    try {
      localStorage.setItem('reviews-voter-id', value);
    } catch (err) {
      log.warn('failed to store voterId: ', err);
    }
  }
}

export async function restoreVoterId() {
  let voterId: string | null = null;
  try {
    voterId = localStorage.getItem('reviews-voter-id');
    if (!validate(voterId ?? 'not-a-uuid')) {
      voterId = null;
    }
  } catch (err) {
    log.warn('failed to restore voterId: ', err);
    voterId = null;
  }
  return voterId;
}

export async function generateVoterId() {
  return uuidv4();
}
